import axios from "axios";
import * as Constants from "../constant";
const InviteUser = async (addUser) => {
	try {
		const response = await axios.post(
			`${Constants?.LOCAL_URL}/invite`,
			addUser
		);
		return response.data;
	} catch (error) {
		return error;
	}
};
export default InviteUser;
